import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import './_concertListingBannerBlock.scss';
import ScrollToButton from '../../common/scrollToButton/scrollToButton';
import { tools } from '../../../utils';

const ConcertListingBannerBlock = ({ bannerData }) => useMemo(() => (
  <>
      <section
          className='banner-section mb-0 concert-list-banner videoBanner'
          id='videoBanner'
      >
        <div
            className='banner-img'
        >
          <Link to='/' className='banner-logo'>
            <img src='/media/images/InClassica_White.svg' alt='logo' />
          </Link>
          <div className='banner-container'>
            <video
                src={bannerData.url}
                autoPlay
                muted
                loop
                webkitplaysinline = 'true'
                playsInline
                className='banner-video'
            />
              <ScrollToButton duration={1500} elementId='calendar-body'

              offset={tools.canUseDOM && document.getElementById('headLine') ? -document.getElementById('headLine').offsetHeight : ''}/>
            <div
                dangerouslySetInnerHTML={{ __html: bannerData.text }}
                style={{ bottom: '25%' }}
                className='banner-context center'
            />
          </div>
        </div>
      </section>
  </>
), [bannerData]);

export default ConcertListingBannerBlock;
